<template>
  <div class="probate-quiz-tool-progress-bar">
    <div class="probate-quiz-tool-progress-bar__thumb" :style="{ '--progress': `${progress}%` }">
      <div class="probate-quiz-tool-progress-bar__thumb-inner"></div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useProbateQuizTool } from '~/composables/probate-quiz-tool';

const { questions, currentQuestionIndex, isFinished } = useProbateQuizTool();

const progress = computed(() => {
  if (questions.value.length === 0) return 0;

  if (isFinished.value) return 100;

  return ((currentQuestionIndex.value + 1) / questions.value.length) * 100;
});
</script>
